import { camelCase, transform, map, unescape } from "lodash";

export const normalizeDropdownOptionsData = <
  T extends object,
  J extends object,
>(
  data: T[],
  key: keyof J | unknown,
): J[] =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  map<T, J>(data, item => {
    return {
      ...item,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      Value: unescape(item[key as keyof J]),
    };
  });

export const normalizeAndCamelcaseDropdownOptionsData = <
  T extends object,
  J extends object,
>(
  data: T[],
  key: keyof J | unknown,
): J[] =>
  map<T, J>(data, item => {
    const transformedData: J = transform<T, J>(item, (result, val, key) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const transformedKey = camelCase(`${key}`) as keyof J;

      (result as J)[transformedKey] = val as never;
    });

    return {
      ...transformedData,
      value: transformedData[key as keyof J],
    };
  });
